import dayjs from 'dayjs';

export const toLocalInputValue = (date: Date): string => {
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

export const toLocalMidnightISO = (dateStr: string): string => {
  let normalized = dateStr.includes('T') ? dateStr : `${dateStr}T00:00:00`;
  if (/T\d{2}:\d{2}$/.test(normalized)) {
    normalized += ':00';
  }
  const offsetMinutes = new Date(normalized).getTimezoneOffset();
  const sign = offsetMinutes <= 0 ? '+' : '-';
  const absMinutes = Math.abs(offsetMinutes);
  const hours = String(Math.floor(absMinutes / 60)).padStart(2, '0');
  const minutes = String(absMinutes % 60).padStart(2, '0');
  return `${normalized}${sign}${hours}:${minutes}`;
};

// Parses a server timestamp TRUSTING its offset. Historically this stripped the trailing 'Z' to
// compensate for locally-run backends writing zone-local wall time mislabelled as UTC — but that
// "fix" shifted every timestamp by -2h on UTC-running environments (dev server, prod). The backend
// now audits in UTC (DatabaseConfig.offsetDateTimeProvider), so the offset is authoritative.
export const parseServerLocalDateTime = (dateStr?: string): Date | null => {
  if (!dateStr) return null;

  const parsed = new Date(dateStr);
  if (Number.isNaN(parsed.getTime())) return null;

  return parsed;
};

export const formatDate = (date: dayjs.Dayjs, config?: { withTime?: boolean }): string => {
  if (config?.withTime) {
    return date.format('YYYY-MM-DD HH:mm');
  }
  return date.format('YYYY-MM-DD');
};

export const formatDateString = (
  date?: string,
  // TODO should be an enum
  config?: { timeOnly?: boolean; withTime?: boolean },
): string => {
  if (!date) {
    return ' - ';
  }
  if (config?.timeOnly) {
    return dayjs(date).format('HH:mm');
  }
  if (config?.withTime) {
    return dayjs(date).format('YYYY-MM-DD HH:mm');
  }
  return dayjs(date).format('YYYY-MM-DD');
};
